/*
 * @Author: Chao Yang
 * @Date: 2020-07-22 03:25:24
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-08-25 12:57:14
 */

import { DashboardProxy } from '../../proxy';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';
import { RootService } from 'src/app/domain/service/root/index';

@Injectable()
export class DashboardService {
  /**
   *
   */
  constructor(private _proxy: DashboardProxy, private rootService: RootService) { }

  aggregateVisible(
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<boolean> {
    return this._proxy.aggregateVisible(accounts, this.rootService.viewDataForAllInvestors);
  }

  GetLayout(name: string) {
    return this._proxy.GetLayout(name);
  }

  GetUserDateRange(
    start: Date,
    end: Date,
    displayclosedaccounts: boolean,
    accounts: IDtoAccountGroup.IAccountItem[]
  ) {
    if (start == null || start == undefined) {
      start = new Date('2000/01/01');
    }
    return this._proxy.GetUserDateRange(
      start,
      end,
      displayclosedaccounts,
      accounts
    );
  }

  GetUserCurrencies() {
    return this._proxy.GetUserCurrencies(this.rootService.viewDataForAllInvestors);
  }

  getAccountBalances2023(start: Date, end: Date, accounts: IDtoAccountGroup.IAccountItem[]) {
    return this._proxy.getAccountBalances2023(start, end, accounts, this.rootService.viewDataForAllInvestors);
  }

  

  updateMyInvestmentsLayout(layoutUpdateDto: { dataLayout: string, documentsOnlyLayout: string, fundId: number[] }) {
    return this._proxy.updateMyInvestmentsLayout(layoutUpdateDto);
  }
}
